// Neuer Kontakt (Tabelle kontakte) – Felder und Payload wie im bisherigen Kontakt-Dialog
// (KontaktErstellenModal.handleSubmit).

export type KontaktArt = 'privatperson' | 'unternehmen';

export const ANREDEN = ['Herr', 'Frau', 'Eheleute', 'Divers'] as const;
export const KONTAKTARTEN = ['Mieter', 'Eigentümer', 'Dienstleister', 'Handwerker', 'Makler', 'Sonstige'] as const;
export const UNTERNEHMENSARTEN = ['Mieter', 'Dienstleister', 'Handwerker', 'Immobilienverwaltung', 'Makler', 'Eigentümer', 'Bank', 'Hausmeister', 'Bekannter', 'Sonstige'] as const;
export const LAENDER = ['Deutschland', 'Österreich', 'Schweiz'] as const;

export interface KontaktEntwurf {
  anrede: string; vorname: string; nachname: string; kontaktart: string; geburtsdatum: string;
  unternehmensart: string; firmenname: string;
  strasse: string; hausnummer: string; plz: string; stadt: string; land: string;
  email: string; festnetz: string; handynummer: string;
  kontoinhaber: string; bank: string; iban: string; bic: string; steuernummer: string; ust_id_nr: string; glaeubiger_id: string;
}

export function leererKontakt(): KontaktEntwurf {
  return {
    anrede: '', vorname: '', nachname: '', kontaktart: '', geburtsdatum: '', unternehmensart: '', firmenname: '',
    strasse: '', hausnummer: '', plz: '', stadt: '', land: '', email: '', festnetz: '', handynummer: '',
    kontoinhaber: '', bank: '', iban: '', bic: '', steuernummer: '', ust_id_nr: '', glaeubiger_id: '',
  };
}

/** Pflicht wie bisher: Nachname (Person) bzw. Firmenname (Unternehmen). */
export function kontaktFehler(art: KontaktArt, k: KontaktEntwurf): string | null {
  if (art === 'privatperson' && !k.nachname.trim()) return 'Bitte mindestens einen Nachnamen eingeben.';
  if (art === 'unternehmen' && !k.firmenname.trim()) return 'Bitte einen Firmennamen eingeben.';
  return null;
}

const t = (s: string) => s.trim() || null;

/** Payload für kontakte.insert – identisch zum bisherigen Dialog. */
export function kontaktPayload(art: KontaktArt, k: KontaktEntwurf): Record<string, string | null> {
  const person = art === 'privatperson';
  return {
    typ: person ? (k.kontaktart || 'Sonstige') : (k.unternehmensart || 'Sonstige'),
    anrede: k.anrede || null,
    vorname: person ? t(k.vorname) : null,
    nachname: person ? k.nachname.trim() : null,
    firma_name: person ? null : k.firmenname.trim(),
    kontaktart: person ? (k.kontaktart || null) : null,
    unternehmensart: person ? null : (k.unternehmensart || null),
    geburtsdatum: k.geburtsdatum || null,
    strasse: t(k.strasse), hausnummer: t(k.hausnummer), plz: t(k.plz), stadt: t(k.stadt), land: k.land || null,
    email: t(k.email), festnetz: t(k.festnetz), handynummer: t(k.handynummer),
    kontoinhaber: t(k.kontoinhaber), bank: t(k.bank), iban: t(k.iban), bic: t(k.bic),
    steuernummer: t(k.steuernummer), ust_id_nr: t(k.ust_id_nr), glaeubiger_id: t(k.glaeubiger_id),
  };
}
